import React from 'react';
import Frame from './components/Frame';
import Home from './components/Home';

function CashInAppV2() {
  return (
    <Frame.Base>
      <Home />
    </Frame.Base>
  );
}

export default CashInAppV2;
